import { TranslationNamespaces, Language } from './namespaces';

// English translations
import enCommon from './en/common.json';
import enNavigation from './en/navigation.json';
import enBlog from './en/blog.json';
import enPages from './en/pages.json';
import enSeo from './en/seo.json';

// French translations
import frCommon from './fr/common.json';
import frNavigation from './fr/navigation.json';
import frBlog from './fr/blog.json';
import frPages from './fr/pages.json';
import frSeo from './fr/seo.json';

export const translations: Record<Language, TranslationNamespaces> = {
  en: {
    common: enCommon,
    navigation: enNavigation,
    blog: enBlog,
    pages: enPages,
    seo: enSeo,
  },
  fr: {
    common: frCommon,
    navigation: frNavigation,
    blog: frBlog,
    pages: frPages,
    seo: frSeo,
  },
  // Arabic placeholder - will be implemented in future phases
  ar: {
    common: enCommon, // Fallback to English until Arabic translations are ready
    navigation: enNavigation,
    blog: enBlog,
    pages: enPages,
    seo: enSeo,
  },
};

export * from './namespaces';
export type { Language, TranslationNamespaces };
